import { useMediaQuery } from "@material-ui/core";
import ForwardIcon from "components/ForwardIcon";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

const TechError = () => {
  const { t } = useTranslation();

  const matchesMediaQuery = useMediaQuery("(min-width: 600px)");

  const history = useHistory();

  return (
    <div
      style={{
        width: matchesMediaQuery ? "58%" : "100%",
        height: "fit-content",
        maxWidth: 750,
        textAlign: "center",
        padding: 16,
      }}
    >
      <h3 style={{ color: "#ffffff", marginTop: 0 }}>{t("login")}</h3>
      <p
        style={{
          color: "#BE2200",
          fontSize: "1.125em",
          margin: "30px 0",
          fontWeight: 700,
        }}
      >
        {t("login_failed")}
      </p>
      <p style={{ color: "#ffffff", fontSize: "1.125em" }}>
        {t("try_again_later")}
      </p>
      <button
        onClick={() => {
          history.push("/login");
        }}
        style={{
          fontSize: "1.125em",
          background: "transparent",
          border: "none",
          textTransform: "uppercase",
          color: "#ffffff",
          cursor: "pointer",
          outline: "none",
          letterSpacing: "0.09375em",
          marginTop: 16,
        }}
      >
        {t("try_again")}
        <ForwardIcon />
      </button>
    </div>
  );
};

export default React.memo(TechError);
